import React from "react";
import { Layout, Grid } from "antd";
import MenuSider from "./components/MenuSider";
import { Outlet } from "react-router-dom";
import AppHeader from "./components/Header";
import NewsBanner from "./components/NewsBanner";
import ModalCompletarPerfil from "../modales/Perfil/components/ModalCompletarPerfil";

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

export default function Application({ logoutLocalFuntion }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <AppHeader
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        logoutLocalFuntion={logoutLocalFuntion}
      />

      <NewsBanner />

      <ModalCompletarPerfil />

      <Layout>
        <Sider
          width={220}
          theme="light"
          collapsible
          breakpoint="md"
          collapsedWidth={isMobile ? 0 : 80}
          collapsed={collapsed}
          onCollapse={(col) => setCollapsed(col)}
          style={{ zIndex: 100 }}
        >
          <MenuSider />
        </Sider>

        <Layout
          style={{
            padding: "0px 0px 15px 0px",
            overflowY: "scroll",
          }}
        >
          <Content
            className="container"
            style={{ padding: isMobile ? "12px" : "18px 21px" }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}
